import React from 'react';

import Button from '@material-ui/core/Button';

export default class FormButton extends React.Component {
  render() {
    let className = this.props.buttonHolder
      ? `button-holder ${this.props.className}`
      : this.props.className;

    return (
      <Button
        id={this.props.id}
        variant={'contained'}
        className={className}
        style={this.props.style}
        color={this.props.color}
        onClick={this.props.handleClick}
      >
        {this.props.label}
      </Button>
    );
  }
}
